export const SET_USER = 'SET_USER';
export const SET_USER_TYPE = 'SET_USER_TYPE';
export const SET_ALL = 'SET_ALL';
export const SET_CLEAR = 'SET CLEAR';
